import Vue from 'vue';
import Echo from "laravel-echo";
import Pusher from 'pusher-js';

import VueRouter from './router/index';
import VuePortal from 'portal-vue';
import VueUniqueIdentifier from 'vue-unique-id';
import VueToasted from 'vue-toasted';

Vue.use(VuePortal);
Vue.use(VueUniqueIdentifier);
Vue.use(VueToasted, {
    position: 'bottom-center',
    keepOnHover: true,
    iconPack: 'fontawesome',
    theme: 'bubble',
    duration: 5000,
    className: 'toast',
    containerClass: 'toast-container'
});

Vue.prototype.$goToError = function() {
    this.$nextTick(() => {
        const items = window.document.getElementsByClassName('validation-error');
        if (items.length > 0) {
            window.scrollTo({
                top: items[0].offsetTop + 450,
                behavior: 'smooth'
            });
        }
    });
};

window.Echo = new Echo({
    broadcaster: "pusher",
    key: window.app.pusher_key,
    cluster: window.app.pusher_cluster,
    encrypted: true
});

new Vue({
    el: '#app',
    router: VueRouter
});
